const e = {
  add: "Añadir",
  cancel: "Cancelar",
  clear: "Borrar",
  confirm: "Confirmar",
  delete: "Borrar",
  redo: "Rehacer",
  save: "Guardar",
  saveAs: "Guardar como",
  undo: "Deshacer"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, o = {
  cancel: "Cancelar",
  confirm: "Confirmar",
  datePlaceholder: "Seleccionar fecha",
  datetimePlaceholder: "Seleccionar fecha y hora",
  endDatePlaceholder: "Fecha de finalización",
  endDatetimePlaceholder: "Fecha y hora de finalización",
  endMonthPlaceholder: "Final de mes",
  monthPlaceholder: "Seleccionar mes",
  now: "Ahora",
  quarterPlaceholder: "Seleccionar Trimestre",
  selectDate: "Seleccionar fecha",
  selectTime: "Seleccionar hora",
  startDatePlaceholder: "Fecha de inicio",
  startDatetimePlaceholder: "Fecha de inicio y hora",
  startMonthPlaceholder: "Mes de inicio",
  today: "Hoy",
  weekPlaceholder: "Seleccionar semana",
  yearPlaceholder: "Seleccione Año",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Seleccione"
}, c = {
  clear: "Borrar",
  negativeText: "Cancelar",
  now: "Ahora",
  placeholder: "Seleccionar hora",
  positiveText: "De acuerdo"
}, l = {
  placeholder: "Introduzca"
}, n = {
  placeholder: "Introduzca"
}, s = {
  placeholder: "Comience a escribir..."
}, t = {
  allRows: "Todas las filas",
  default: "Por defecto",
  deleteLayoutDescription: "¿Seguro que desea eliminar este diseño?",
  discardChanges: "Descartar cambios",
  discardLayoutChanges: "Descartar los cambios de diseño",
  enterLayoutName: "Introduzca el nombre del diseño",
  enterRowNumber: "Introduzca el número de filas",
  fieldsSelected: "campos seleccionados",
  freezeColumnDescription: "Congelar la columna a la izquierda",
  freezeUptoColumn: "Congele hasta la columna",
  frozen: "Congelado",
  layoutName: "Nombre del diseño",
  manageColumns: "Gestionar columnas",
  none: "Ninguno",
  reorderRows: "Reordenar Filas",
  rowsSelected: "filas seleccionadas",
  saveLayoutAs: "Guardar diseño como",
  saveLayoutNew: "Guardar nuevo diseño",
  search: "Buscar",
  searchColumnsPlaceholder: "Buscar columnas",
  searchFieldsPlaceholder: "Buscar campos",
  selectAll: "Seleccionar todo",
  setTableHeight: "Establecer la altura de la mesa",
  unfreeze: "Descongelar",
  unsavedChanges: "Tiene cambios sin guardar",
  unsavedChangesDescription: "Puede que haya uno o más cambios sin guardar. ¿Desea guardarlos?"
}, i = {
  at: "en",
  colorAlreadyUsed: "Seleccionar un color diferente o usar el actual",
  colorNamePlaceholder: "Introducir el nombre",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Por favor, seleccione un nombre de color distinto",
  noColorsAdded: "No tiene ningún color en esta sección."
}, d = {
  searchPlaceholder: "Buscar"
}, u = {
  invalidPastedData: "Datos pegados no válidos"
}, h = {
  of: "de",
  page: "Página",
  rowsPerPage: "Filas por página"
}, m = {
  failedToUpload: "Error al subir",
  retry: "Reintentar",
  clickToUpload: "hacer clic para subir",
  orDragAndDrop: "O Arrastra y suelta",
  supportedFileTypes: "Tipos de archivo compatibles:"
}, p = {
  global: e,
  Progress: a,
  DatePicker: o,
  Select: r,
  TimePicker: c,
  Input: l,
  InputNumber: n,
  InputTag: s,
  HLDataTable: t,
  ColorPicker: i,
  InputPhone: d,
  InputOtp: u,
  Pagination: h,
  Upload: m
};
export {
  i as ColorPicker,
  o as DatePicker,
  t as HLDataTable,
  l as Input,
  n as InputNumber,
  u as InputOtp,
  d as InputPhone,
  s as InputTag,
  h as Pagination,
  a as Progress,
  r as Select,
  c as TimePicker,
  m as Upload,
  p as default,
  e as global
};
